import React, { useCallback } from 'react'
import { Main, MainBody, MainTop, MainTopTitle } from '@/components/Layout/Layout.Main'
import { ButtonSection } from '@/components/Layout'
import { WhiteBox } from '@/components/Layout/Layout.Box'
import Resx from '@/components/Resx'
import { Col, Form, FormGroup, Label, Row, Input } from 'reactstrap'
import { ValidationBoundary, ValidationState, Validator, ServerValidator } from '@/components/validation'
import context from '@/context'
import { actionCreators } from '@/store/usersManagement'
import Icon from '@/components/Icon'
import validateUserEmail from '@/components/userManagement/validateUserEmail'
import { IndividualSelector } from '@/components/individualSelector'
import { useSelector } from 'react-redux'
import { useDispatch } from '@/hooks/dispatch'

export const UserManagementAddUser = React.memo((props) => {
  const { user, userCreating, error } = useSelector(state => {
    return {
      user: state.usersManagement.user,
      userCreating: state.usersManagement.userCreating,
      error: state.usersManagement.error
    }
  })

  const [updateDto, resetState, createUser] = useDispatch(
    [actionCreators.updateUserDto,
      actionCreators.resetState,
      actionCreators.createUser
    ])

  const onSaveClick = useCallback(() => {
    createUser()
  }, [createUser])

  const onCancelClick = useCallback(() => {
    resetState()
    props.history.push('/users')
  }, [props.history, resetState])

  const onIndividualChange = useCallback(({ value }) => {
    updateDto({ individualId: value })
  }, [updateDto])

  const dataSource = useCallback(
    (...params) => {
      return context.api.individualService.getIndividualsWithoutUserAccount(...params)
    }, [])

  return (
    <Main>
      <MainTop>
        <MainTopTitle backUrl='/users'>
          <Resx name='UsersManagement.Title' />
        </MainTopTitle>
      </MainTop>
      <MainBody clear>
        <Row>
          <Col className='col-md-3'>
            <WhiteBox>
              <ValidationBoundary serverError={error}>
                <Form>
                  <FormGroup>
                    <Label><Resx name='UsersManagement.AccountEmail' /></Label>
                    <ServerValidator
                      name='email'
                      value={user.email || ''}
                      required
                      onValidate={({ value }) => validateUserEmail({ value })}
                      serverValidation={(email) => context.api.userManagementService.validateEmailIsUnique(email)}>
                      <Input value={user.email || ''} onChange={(e) => updateDto({ email: e.target.value })} />
                    </ServerValidator>
                  </FormGroup>
                  <FormGroup>
                    <Label><Resx name='UsersManagement.SelectIndividual' /></Label>
                    <Validator name='individual' value={user.individualId} required>
                      <IndividualSelector
                        dataSource={dataSource}
                        onChange={onIndividualChange}
                        value={user.individualId}
                        onlyActive />
                    </Validator>
                  </FormGroup>
                  <ButtonSection className='mt-4'>
                    <button className='btn btn-secondary' onClick={onCancelClick}><Resx name='Common.Cancel' /></button>
                    <ValidationState render={({ isValid, serverError }) =>
                      <React.Fragment>
                        {serverError && serverError.message &&
                          <span className='error'><Resx name={serverError.message} /></span>}
                        <button className='btn btn-success ml-auto' onClick={onSaveClick}
                          disabled={userCreating || !isValid}>
                          <Icon name={userCreating ? 'bx-loader bx-spin' : 'save'} />
                          <span><Resx name='Common.SaveAndClose' /></span>
                        </button>
                      </React.Fragment>
                    } />
                  </ButtonSection>
                </Form>
              </ValidationBoundary>
            </WhiteBox>
          </Col>
        </Row>
      </MainBody>
    </Main>
  )
})



// WEBPACK FOOTER //
// ./src/report-app/pages/usersManagement/addUser.js